import React from 'react';
import { compose } from 'ramda';

import PropertyManager from '@synergycms_core/components/HoC/propertyManager';

import SearchOptionFilterOption from './SearchOptionFilterOption.jsx';

import styleFile from './SearchOptionFilterGroup.js';
import RichText from '@synergycms_core/components/generic/RichText';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';

class SearchOptionFilterGroup extends React.Component {
  static displayName = 'SearchOptionFilterGroup';
  render() {
    const { config, theme } = this.props;
    const { classes } = theme.styles;
    const { title, options, onChange, type } = config;

    return (
      <div className={theme.computedInnerStyle} key={type}>
        <div className={classes.title}>
          <RichText translate={true} ucFirst={true}>
            {title && title.toLowerCase()}
          </RichText>
        </div>
        <ul className={classes.group}>
          {options
            .map((data, code) => {
              const key = `${type}-${code}`;
              return <SearchOptionFilterOption onChange={onChange} code={code} data={data} type={type} key={key} />;
            }).valueSeq()}
        </ul>
      </div>
    );
  }
}

export default compose(
  PropertyManager(['theme', 'title', 'options', 'onChange', 'type']),
  withThemeJSS({ styleFile })
)(SearchOptionFilterGroup);
